import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { BUSINESS_CATEGORIES } from "@/lib/categories";

const box = "rounded-xl bg-[#0B0F19] border-[#26334D] focus-visible:ring-[#FF3B6B]";

export function BusinessFields({ form, setForm, field }) {
  return (
    <div data-testid="business-fields" className="space-y-4">
      {field("business_name", "Business name", "text", "Lucky Strike Lanes")}
      <div className="space-y-2">
        <Label className="text-slate-300">Business type</Label>
        <Select value={form.business_type} onValueChange={(v) => setForm({ ...form, business_type: v })}>
          <SelectTrigger data-testid="auth-business-type-select" className={`h-12 ${box}`}>
            <SelectValue placeholder="Pick what you offer" />
          </SelectTrigger>
          <SelectContent>
            {BUSINESS_CATEGORIES.map((c) => (
              <SelectItem key={c.id} value={c.id} data-testid={`business-type-${c.id}`}>{c.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-2">
        <Label htmlFor="business_description" className="text-slate-300">What do visitors do there?</Label>
        <Textarea id="business_description" data-testid="auth-business_description-input" required minLength={10}
          placeholder="24-lane bowling alley with arcade, bar and late-night glow bowling."
          value={form.business_description} onChange={(e) => setForm({ ...form, business_description: e.target.value })}
          className={box} />
        <p className="text-xs text-slate-500">Business accounts are for entertainment, restaurants and attractions.</p>
      </div>
    </div>
  );
}
